/*
  ALTRA — スタックハイト ファセットを二点レンジスライダーへ転換
  ==================================================================
  Shopify ネイティブの Storefront filtering はレンジ型 UI が価格(price_range)専用で、
  数値メタフィールド(specs.stack_height_mm)は離散値の list(チェックボックス)としてしか
  描画されない。本スクリプトはそのチェックボックスリストの上に二点スライダー UI を被せる
  progressive enhancement。裏側は「選択レンジ内の離散値を一括チェック」への変換で、
  URL 状態・submit・再描画は Rise ネイティブ機構(facets.js)のまま＝markup 非改変・
  JS 無効時はチェックボックスへ graceful degradation する(防水ピルと同じ隔離方針)。

  設計メモ:
  - スライダーは index ベース(実在値のみへスナップ): 値域は歯抜け(例 14,15,17,19,...)のため
    mm 連続値だと「実在値ゼロのレンジ」が選べてしまい、チェックゼロ＝軸フィルタ不成立
    (全件表示)という直感と逆の結果を生む。index 化で常に1値以上を含むレンジのみ選べる。
  - 全域選択(lo=最小, hi=最大)は「フィルタなし」として全チェックを外す(URL を汚さない)。
  - フィルタ値は保存仕様(docs/product_data.md)どおり踵(ヒール)側単一値。readout に
    「かかと側」を常時注記する(PDP はつま先先行の両値併記のため基準の相違をここで明示)。
  - 再構築: facets.js renderFilters は details(.js-filter)の innerHTML を差し替えるが、
    操作起点の軸だけは renderCounts で fieldset(.facets-wrap)/.mobile-facets__list の
    outerHTML 差し替えに留まる。スライダーを「リストの前の兄弟」に挿すことで自軸操作では
    生存し、他軸操作・popstate・SP 適用では消える → MutationObserver が再構築する。
    消失中は CSS の兄弟セレクタ(component-facets-altra.css)が外れてチェックボックスが
    自動復帰する自己修復構造(無条件 display:none にしない)。
  - desktop: change(サムを離した)時に checkbox 群を設定し、checkbox からの bubbling input
    イベント1発で facets.js の debounce submit を起こす。ドラッグ中の input は
    stopPropagation でライブ再描画を抑止(1ドラッグ=1往復)。
  - SP(#FacetFiltersFormMobile): checkbox を設定するだけ(submit は「適用」ボタン＝
    facet-mobile-apply.js の管轄。input 抑止も同スクリプトが担うので dispatch 不要)。
    ドロワーの×キャンセルで restoreToApplied が checkbox を巻き戻すため、ドロワー
    再オープン(toggle capture)時に SP 側スライダーを破棄→再構築して位置を再同期する。
  - アクティブチップ統合: レンジ選択は値の数だけネイティブチップが並ぶ(最大18個)ため、
    スタック軸のチップ群を1個の合成チップ「<軸ラベル>: X〜Ymm」へ集約する。先頭チップの
    クローンを雛形にして×アイコン・facet-remove 挙動(クリックで renderPage)・チップ装飾を
    そのまま継承し、href はスタック系パラメータを全除去した URL に差し替える。チップの
    判別はラベル文字列でなく href の URL diff(スタック param 集合だけが現 URL と異なり
    他 param は一致)で行い、「すべてを削除する」(.active-facets__button-remove)は除外する。
*/
(function () {
  var PARAM = 'filter.p.m.specs.stack_height_mm';
  var NOTE_LABEL = 'かかと側';
  var CHIP_CLASS = 'altra-stack-chip';

  function toInt(value) {
    return parseInt(value, 10);
  }

  function getCheckboxes(details) {
    return Array.prototype.slice.call(
      details.querySelectorAll('input[type="checkbox"][name="' + PARAM + '"]')
    );
  }

  /* ── スライダー構築 ─────────────────────────────────────────── */

  function buildSlider(details) {
    if (details.querySelector('.altra-stack-slider')) return;
    var boxes = getCheckboxes(details);
    if (boxes.length < 2) return; // 値が1つの文脈ではスライダー不要(チェックボックスのまま)

    var seen = {};
    var values = [];
    boxes.forEach(function (box) {
      var v = toInt(box.value);
      if (!isNaN(v) && !seen[v]) {
        seen[v] = true;
        values.push(v);
      }
    });
    values.sort(function (a, b) {
      return a - b;
    });
    var maxIdx = values.length - 1;
    var isMobile = details.id.indexOf('Details-Mobile') === 0;

    // 挿入先: リスト(desktop=fieldset .facets-wrap / SP=.mobile-facets__list)の直前の兄弟
    var list = details.querySelector(isMobile ? '.mobile-facets__list' : '.facets-wrap');
    if (!list || !list.parentElement) return;

    // 初期位置: チェック済み(=適用中 URL 由来)から導出、無ければ全域
    var lo = 0;
    var hi = maxIdx;
    var checkedValues = boxes
      .filter(function (box) {
        return box.checked;
      })
      .map(function (box) {
        return toInt(box.value);
      });
    if (checkedValues.length) {
      lo = values.indexOf(Math.min.apply(null, checkedValues));
      hi = values.indexOf(Math.max.apply(null, checkedValues));
      if (lo < 0) lo = 0;
      if (hi < 0) hi = maxIdx;
    }

    var root = document.createElement('div');
    root.className = 'altra-stack-slider';
    root.innerHTML =
      '<div class="altra-stack-slider__readout">' +
      '<span data-stack-readout></span>' +
      '<span class="altra-stack-slider__note">' + NOTE_LABEL + '</span>' +
      '</div>' +
      '<div class="altra-stack-slider__track">' +
      '<span class="altra-stack-slider__fill" data-stack-fill></span>' +
      '<input type="range" data-stack-thumb="lo" min="0" max="' + maxIdx + '" step="1" value="' + lo + '" aria-label="スタックハイト下限(かかと側)">' +
      '<input type="range" data-stack-thumb="hi" min="0" max="' + maxIdx + '" step="1" value="' + hi + '" aria-label="スタックハイト上限(かかと側)">' +
      '</div>';
    list.parentElement.insertBefore(root, list);

    var loInput = root.querySelector('[data-stack-thumb="lo"]');
    var hiInput = root.querySelector('[data-stack-thumb="hi"]');

    function state() {
      var a = toInt(loInput.value);
      var b = toInt(hiInput.value);
      return { lo: Math.min(a, b), hi: Math.max(a, b) };
    }

    function paint() {
      var s = state();
      root.querySelector('[data-stack-readout]').textContent =
        values[s.lo] + 'mm 〜 ' + values[s.hi] + 'mm';
      var fill = root.querySelector('[data-stack-fill]');
      fill.style.left = (s.lo / maxIdx) * 100 + '%';
      fill.style.width = ((s.hi - s.lo) / maxIdx) * 100 + '%';
      loInput.setAttribute('aria-valuetext', values[toInt(loInput.value)] + 'mm');
      hiInput.setAttribute('aria-valuetext', values[toInt(hiInput.value)] + 'mm');
      // サム重なり時の掴み分け: 通常は hi(後勝ち DOM)が前面。両サムが最大端に
      // 密着すると hi の下の lo が掴めなくなるため、そのときだけ lo を前面へ。
      var overlapped = toInt(loInput.value) === toInt(hiInput.value);
      loInput.style.zIndex = overlapped && toInt(loInput.value) === maxIdx ? '3' : '1';
      hiInput.style.zIndex = '2';
    }

    function applyToCheckboxes() {
      var s = state();
      var isFullRange = s.lo === 0 && s.hi === maxIdx; // 全域=フィルタなし
      // renderCounts の fieldset 差し替え後も常に現物を掴む(古い参照を持たない)
      getCheckboxes(details).forEach(function (box) {
        var v = toInt(box.value);
        box.checked = !isFullRange && v >= values[s.lo] && v <= values[s.hi];
      });
    }

    function submitDesktop() {
      // 自軸の checkbox から input を1発 bubble させる: facets.js の debounce submit が
      // 走り、event 起点が自軸=renderFilters が innerHTML 差し替えを免れてスライダーが生存
      var box = getCheckboxes(details)[0];
      if (box) box.dispatchEvent(new Event('input', { bubbles: true }));
    }

    function onDrag(event) {
      event.stopPropagation(); // ドラッグ中の input で facets.js のライブ submit を起こさない
      paint();
    }

    function onRelease(event) {
      event.stopPropagation();
      var s = state();
      loInput.value = s.lo; // 交差(lo>hi)したドラッグを確定時に正規化
      hiInput.value = s.hi;
      paint();
      applyToCheckboxes();
      if (!isMobile) submitDesktop();
    }

    [loInput, hiInput].forEach(function (input) {
      input.addEventListener('input', onDrag);
      input.addEventListener('change', onRelease);
    });

    paint();
  }

  function initAll() {
    document
      .querySelectorAll('details[id*="' + PARAM + '"]')
      .forEach(buildSlider);
  }

  /* ── アクティブチップ統合 ───────────────────────────────────── */

  function currentStackValues() {
    return new URLSearchParams(window.location.search)
      .getAll(PARAM)
      .map(toInt)
      .sort(function (a, b) {
        return a - b;
      });
  }

  // 「スタック param 集合だけが現 URL と異なり、他 param(page 除く)は一致」なら stack チップ
  function chipRemovesOnlyStack(anchor) {
    var href = anchor.getAttribute('href') || '';
    var current = new URLSearchParams(window.location.search);
    var target = new URLSearchParams(href.split('?')[1] || '');
    if (current.getAll(PARAM).join(',') === target.getAll(PARAM).join(',')) return false;
    function others(params) {
      var out = [];
      params.forEach(function (value, key) {
        if (key !== PARAM && key !== 'page') out.push(key + '=' + value);
      });
      return out.sort().join('&');
    }
    return others(current) === others(target);
  }

  function consolidateChips() {
    var stack = currentStackValues();
    ['.active-facets-desktop', '.active-facets-mobile'].forEach(function (selector) {
      var container = document.querySelector(selector);
      if (!container) return;
      var chips = Array.prototype.filter.call(
        container.querySelectorAll('facet-remove:not(.' + CHIP_CLASS + ')'),
        function (chip) {
          var anchor = chip.querySelector('a');
          return (
            anchor &&
            !anchor.classList.contains('active-facets__button-remove') &&
            chipRemovesOnlyStack(anchor)
          );
        }
      );
      var existing = container.querySelector('.' + CHIP_CLASS);
      if (!chips.length) {
        if (existing) existing.remove();
        return;
      }
      var hash = stack.join(',');
      if (existing && existing.dataset.stackHash === hash) {
        // 合成済み: ネイティブ側チップの非表示だけ再徹底(部分再描画で復活しうる)
        chips.forEach(function (chip) {
          chip.style.display = 'none';
        });
        return;
      }
      if (existing) existing.remove();

      // 先頭のネイティブチップを雛形にクローン(×アイコン・facet-remove 挙動・装飾を継承)
      var synthetic = chips[0].cloneNode(true);
      synthetic.classList.add(CHIP_CLASS);
      synthetic.dataset.stackHash = hash;
      synthetic.style.display = ''; // 雛形が非表示化済みでも合成チップは表示する
      var anchor = synthetic.querySelector('a');
      var params = new URLSearchParams(window.location.search);
      params.delete(PARAM);
      params.delete('page');
      var query = params.toString();
      anchor.setAttribute('href', window.location.pathname + (query ? '?' + query : ''));

      // ラベル: 雛形の「<軸ラベル>: <値>mm」から軸ラベルを継承しレンジ表記へ差し替える
      // (S&D 登録名に依存しない)。×svg と visually-hidden はテキストノード以外なので温存。
      var range = stack.length === 1 ? stack[0] + 'mm' : stack[0] + '〜' + stack[stack.length - 1] + 'mm';
      var inner = synthetic.querySelector('.active-facets__button-inner') || anchor;
      var replaced = false;
      Array.prototype.forEach.call(inner.childNodes, function (node) {
        if (node.nodeType !== 3 || !node.textContent.trim()) return;
        if (replaced) {
          node.textContent = '';
          return;
        }
        var axisLabel = node.textContent.split(':')[0].trim();
        node.textContent = ' ' + axisLabel + ': ' + range + ' ';
        replaced = true;
      });

      chips[0].parentElement.insertBefore(synthetic, chips[0]);
      chips.forEach(function (chip) {
        chip.style.display = 'none';
      });
    });
  }

  /* ── 再構築・再同期のトリガー ───────────────────────────────── */

  // facets.js の再描画(innerHTML 差し替え)でスライダー/合成チップが消えたら作り直す。
  // 自前の DOM 挿入も childList 変異を起こすが、次スキャンは「既存あり」で no-op に
  // 収束する(スタイル変更は childList 監視の対象外)ため無限ループしない。
  var scheduled = null;
  function scheduleScan() {
    if (scheduled) return;
    scheduled = requestAnimationFrame(function () {
      scheduled = null;
      initAll();
      consolidateChips();
    });
  }

  // SP: ドロワー再オープン時にスライダーを作り直して checkbox 状態と再同期する
  // (×キャンセル時に facet-mobile-apply.js の restoreToApplied が checkbox を巻き戻すため)。
  // toggle はバブルしないが capture なら document で捕捉できる。
  document.addEventListener(
    'toggle',
    function (event) {
      var disclosure = event.target;
      if (
        !disclosure.classList ||
        !disclosure.classList.contains('mobile-facets__disclosure') ||
        !disclosure.open
      ) {
        return;
      }
      var mobileForm = document.getElementById('FacetFiltersFormMobile');
      if (!mobileForm) return;
      mobileForm.querySelectorAll('.altra-stack-slider').forEach(function (slider) {
        slider.remove();
      });
      initAll(); // 同期的に再構築(チェックボックスが見える瞬間を作らない)
    },
    true
  );

  function start() {
    initAll();
    consolidateChips();
    new MutationObserver(scheduleScan).observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
